// Generated by CoffeeScript 1.12.7

/**
Check if a given value is a valid mongodb object id

@method isObjectId
@param {String} value a string to test
@return {Boolean}
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/is_object_id',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.isObjectId = factory();
  }
})(this, function() {
  var isObjectId;
  return isObjectId = function(value) {
    return /^[0-9a-fA-F]{24}$/.test(value);
  };
});

